export const API_PREFIX = '/agent-api';
const buildUrl = (path: string) => `${API_PREFIX}${path}`;

const API = {
    marketplace: {
        list: buildUrl('/marketplace/list')
    },
    chat: {
        sessions: buildUrl('/chat/sessions'),
        execute: buildUrl('/chat/execute'),
        context: buildUrl('/chat/context'),
    },
    transformations: {
        base: buildUrl('/transformations'),
        execute: buildUrl('/transformations/execute'),
        defaultPrompt: buildUrl('/transformations/default-prompt'),
    },
    sources: {
        base: buildUrl('/sources'),
        statusBatch: buildUrl('/sources/status'),
        status: (sourceId: string) => buildUrl(`/sources/${sourceId}/status`),
    },
    materials: {
        base: buildUrl('/materials'),
        stats: buildUrl('/materials/stats'),
        dirs: buildUrl('/materials/dirs'),
        move: buildUrl('/materials/move'),
        file: (itemId: string) => buildUrl(`/materials/${itemId}/file`),
    },
    models: {
        base: buildUrl('/models'),
        defaults: buildUrl('/models/defaults'),
        providers: buildUrl('/models/providers'),
        providerSettings: buildUrl('/models/providers/settings'),
    },
    notebooks: {
        base: buildUrl('/notebooks'),
    },
    notes: {
        base: buildUrl('/notes'),
    },
    insights: {
        base: buildUrl('/insights'),
    },
    embed: {
        base: buildUrl('/embed'),
    },
    embeddings: {
        rebuild: buildUrl('/embeddings/rebuild'),
    },
    search: {
        base: buildUrl('/search'),
        ask: buildUrl('/search/ask'),
    },
    settings: {
        base: buildUrl('/settings'),
    },
    graphrag: {
        corpusState: buildUrl('/graphrag/corpus/state'),
        chatStream: buildUrl('/graphrag/chat/stream'),
        corpusFile: buildUrl('/graphrag/corpus/file'),
        corpusUpload: buildUrl('/graphrag/corpus/upload'),
        corpusLogs: buildUrl('/graphrag/corpus/logs'),
        corpusIndexStop: buildUrl('/graphrag/corpus/index/stop'),
        corpusArchiveList: buildUrl('/graphrag/corpus/archive/list'),
        corpusArchiveCreate: buildUrl('/graphrag/corpus/archive/create'),
        corpusArchiveRestore: buildUrl('/graphrag/corpus/archive/restore'),
        corpusArchiveRename: buildUrl('/graphrag/corpus/archive/rename'),
        corpusArchiveDelete: buildUrl('/graphrag/corpus/archive/delete'),
        corpusKgRename: buildUrl('/graphrag/corpus/kg/rename'),
        corpusRemove: buildUrl('/graphrag/corpus/remove'),
        indexStream: buildUrl('/graphrag/index/stream'),
        data: buildUrl('/graphrag/data'),
        build: buildUrl('/graphrag/build'),
    },
    commands: {
        jobs: buildUrl('/commands/jobs')
    }
};

export default API;
